import * as Sentry from "@sentry/gatsby"

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.BRANCH === "main" ? "production" : "preview",
  sampleRate: 0.7,
})
